import * as React from "react";
import {
  TextField,
  BooleanField,
  ImageField,
  Show,
  NumberField,
  usePermissions,
  useRecordContext,
  Title,
  ArrayField,
  SingleFieldList,
  ChipField,
  FunctionField,
} from "react-admin";
import { ROLE_TYPES } from "../enums/Roles";
import { SimpleShowLayout } from "../common/SimpleShowLayout";

const PlaceTypeTitle = () => {
  const record = useRecordContext();
  return <Title title={`Tipo de Lugar "${record?.name}"`} />;
};

const PlaceTypeShow = () => {
  const { permissions } = usePermissions();
  return (
    <Show title={<PlaceTypeTitle />}>
      <SimpleShowLayout>
        {permissions === ROLE_TYPES.ADMIN && (
          <TextField source="id" label="ID" />
        )}
        <TextField source="name" label="Nombre" />
        <ImageField source="image" label="Imagen" />
        <ArrayField source={"mealTimes"} label={"Momentos ideales"}>
          <SingleFieldList linkType={false}>
            <FunctionField
              render={(record) => (
                <ChipField
                  record={{ name: record }}
                  source="name"
                  size="small"
                />
              )}
            />
          </SingleFieldList>
        </ArrayField>
        <NumberField source="order" label="Orden" />
        <TextField source="iconName" label="Nombre de Ícono" />
        <BooleanField source="visible" label="Visible" />
        <BooleanField source="active" label="Activo" />
      </SimpleShowLayout>
    </Show>
  );
};

export default PlaceTypeShow;
